import { Icon } from 'Components';

export interface NavItemConfig {
	key: string;
	label: string;
	icon?: React.ReactNode;
	isExternal?: boolean;
	path?: string;
	children?: Omit<NavItemConfig, 'children'>[];
}

export const mainNavItems: NavItemConfig[] = [
	{
		key: 'dashboard',
		label: 'Dashboard',
		icon: <Icon type="dashboardIcon" role="img" />,
		path: '/learning-manager/dashboard'
	},
	{
		key: 'phishing',
		label: 'Phishing',
		icon: <Icon type="phishingIcon" role="img" />,
		path: '/learning-manager/phishing'
	},
	{
		key: 'training',
		label: 'Training',
		icon: <Icon type="trainingIcon" role="img" />,
		children: [
			{
				key: 'my-courses',
				label: 'My Courses',
				icon: <Icon type="coursesIcon" role="img" />,
				path: '/learning-manager/my-courses'
			},
			{
				key: 'assignments',
				label: 'Assignments',
				icon: <Icon type="assignmentsIcon" role="img" />,
				path: '/learning-manager/assignments'
			}
		]
	},
	{
		key: 'reports',
		label: 'Reports',
		icon: <Icon type="reportsIcon" role="img" />,
		children: [
			{
				key: 'reports-overview',
				label: 'Overview',
				icon: <Icon type="reportsIcon" role="img" />,
				path: '/learning-manager/overview'
			}
			// {
			// 	key: 'reports-completion',
			// 	label: 'Completion',
			// 	path: '/learning-manager/reports/completion'
			// }
		]
	},
	{
		key: 'settings',
		label: 'Settings',
		icon: <Icon type="settingsIcon" role="img" />,
		children: [
			{
				key: 'settings-opt',
				label: 'Settings',
				path: '/learning-manager/settings/test'
			}
		]
	},
	{
		key: 'modules',
		label: 'Modules',
		icon: <Icon type="modulesIcon" role="img" />,
		children: [
			{
				key: 'modules-library',
				label: 'Library',
				path: '/learning-manager/modules/library'
			}
		]
	}
];

export const bottomNavItems: NavItemConfig[] = [
	{
		key: 'language',
		label: 'English',
		icon: <Icon type="languageIcon" role="img" />,
		children: [{ key: 'lang-en', label: 'English', path: '#' }]
	},
	{
		key: 'help',
		label: 'Help',
		icon: <Icon type="helpIcon" role="img" />,
		isExternal: true,
		path: process.env.REACT_APP_VENZA_HELP_LINK
	}
];
